import { processInteraction } from '@/helpers/interaction';

function interactions(state) {
  return panelId =>
    (state.panelInteractions[panelId] || [])
      .map(interactionId => processInteraction(state.interactions[interactionId]))
      .sort((a, b) => new Date(b.date_created).getTime() - new Date(a.date_created).getTime());
}

function interactionsOnAir(state) {
  return interactions(state)('onAir');
}

function pollStats(state) {
  return panelId => state.instantPollResults[panelId] || [];
}

export default { interactions, interactionsOnAir, pollStats };



// WEBPACK FOOTER //
// ./src/store/modules/interaction/getters.js